import React from "react"

import { FontAwesomeIcon } from "@appcharge/shared-ui"

import { cn } from "components/lib/utils"

import { TriggerProps, TriggerState } from "./types"

export const Trigger = ({ onClick, label, labelParts, isActive, state, hideIndicator }: TriggerProps) => {
    const parts = labelParts || [label]

    return (
        <div
            className={cn(
                "flex items-center justify-center gap-3 h-8 p-2 pl-3 pr-3 rounded-md border border-dashed border-base-input cursor-pointer text-base-foreground transition-colors",
                !isActive && "hover:bg-base-muted",
                isActive && "bg-base-accent bg-purple-50 border-indigo-400 border-solid"
            )}
            onClick={onClick}
        >
            {parts.map((part, index) => (
                <React.Fragment key={index}>
                    {index > 0 && <div className="h-4 border-r border-gray-300"></div>}
                    <div className={cn(isActive && "text-indigo-600", "text-xs font-medium")}>{part}</div>
                </React.Fragment>
            ))}
            {state === TriggerState.EMPTY && <FontAwesomeIcon icon="fa-regular fa-plus-circle" className={cn(isActive && "text-indigo-600", "!text-md !w-6 !h-6")} />}
            {state === TriggerState.FILLED && !hideIndicator && <><div className="h-4 border-r border-gray-300"></div> <div className="w-3.5 h-3.5 bg-indigo-600 rounded-full"></div></>}
        </div>
    )
}